module.exports = __webpack_public_path__ + "static/media/word2.077d045b.svg";